export default {
    "400": {
        title: "400",
        desc: "抱歉，你请求的参数不正确",
    },
    "403": {
        title: "403",
        desc: "抱歉，你无权访问该页面",
    },
    "404": {
        title: "404",
        desc: "抱歉，你访问的页面不存在",
    },
    "500": {
        title: "500",
        desc: "抱歉，服务器出错了",
    },
    checkError: {
        title: "链接无效",
        desc: "",
    },
    codeError: {
        title: "",
        desc: "",
    }
};
